export const environment = {
  production: false,
  BaseUrl: 'https://staging.memorabid.com/',
  APIBaseUrl: "https://backstart.staging.memorabid.com/api/",
  recaptcha: {
    siteKey: '6LfrPlgfAAAAAE1WcS0VWC-rO-YtDrANWhMRdL71',
  },
  APPOrigin: 'https://staging.memorabid.com',
  facebookPixelId: '682934686242366',
  canonicalUrl: 'https://staging.memorabid.com/',
  paypalClientId: 'AZIPyDr6p36mVjb9k6IZlfLTQWCiHKmIZO3EkfaEyyIeRU_v5DUCsfadYh12W58V6Rz83qOpiihWbpZH',
  stripePublicKey: 'pk_test_51KW0lyHIg3lbZ0HBudFf6fej7AiEgwJjfNqftuq6j63IvRCRia5VOOc2hp2o5V7qJeNOV4MGwSGPzvAQpXYu1u5K00L2WXska1'
};


